import React, { useRef, useState, useEffect } from "react";

import styles from "./ServiceBooking.module.css";
import ServiceCard from "../ServiceCard/ServiceCard";
import VehiclePopup from "../VehiclePopup/VehiclePopup";
import BookingSuccess from "../BookingSuccess/BookingSuccess";
import { Service, Vehicle, Appointment } from "../types";
import { BiPlus } from "react-icons/bi";
import { Image } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { FiGrid, FiTruck } from "react-icons/fi";
import { FaCar } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import {
  MdDoNotDisturb,
  MdGpsFixed,
  MdLocationOn,
  MdOutlineCalendarMonth,
  MdSearch,
} from "react-icons/md";
import noProductFound from "../../../../assets/images/product-not-found.png";
import { CiClock2, CiLocationArrow1, CiLocationOn } from "react-icons/ci";
import { Calendar } from "primereact/calendar";
import HorizontalDatePicker from "../../../HorizontalDatePicker/HorizontalDatePicker";
// import walletIcon from "../../../assets/images/wallet-icon.png";
import useWalletAPI from "../../../../api/useWalletAPI";
import usePreDefinedListAPI from "../../../../api/usePreDefinedListAPI";
import useOrderAPI from "../../../../api/useOrderAPI";
import usePackageAPI from "../../../../api/usePackageAPI";
import useVehicleAPI from "../../../../api/useVehicleAPI";
import useHeroAPI from "../../../../api/useHeroAPI";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { AutoComplete } from "primereact/autocomplete";
import locationPin from "../../../../assets/images/location_pin.png";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../redux/loadingSlice";
import { useNavigate } from "react-router-dom";
import { format, isWithinInterval } from "date-fns";
import useCartAPI from "../../../../api/useCartAPI";
import { Toast } from "primereact/toast";
import carStand from "../../../../assets/images/car-stand.png";

import { setTabIndex } from "../../../../redux/tabIndexSlice";
import AppSkeleton from "../../../AppSkeleton/AppSkeleton";
// Hardcoded service list using the high-quality generated images and placeholder visuals

const INITIAL_VEHICLES: Vehicle[] = [
  {
    id: "v1",
    nickname: "My Daily Driver",
    vin: "WBS53AY06NS8*****",
    year: "2022",
    make: "BMW",
    model: "M3",
    tags: ["6-CYL TWIN-TURBO", "ALL-WHEEL DRIVE"],
    lastService: "3 MO AGO",
  },
  {
    id: "v2",
    nickname: "Weekend Cruiser",
    vin: "WUAFFFGEO MA0*****",
    year: "2021",
    make: "Audi",
    model: "RS6",
    tags: ["V8 BITURBO", "QUATTRO"],
    lastService: "8 MO AGO",
  },
];

const INITIAL_APPOINTMENTS: Appointment[] = [
  {
    id: "a1",
    serviceId: "s2",
    serviceTitle: "Wheel Alignment",
    vehicleId: "v1",
    vehicleName: "2022 BMW M3",
    offer_price: 85.0,
    date: "2026-05-14",
    status: "Completed",
  },
  {
    id: "a2",
    serviceId: "s6",
    serviceTitle: "Performance Brake Service",
    vehicleId: "v2",
    vehicleName: "2021 Audi RS6",
    offer_price: 149.0,
    date: "2026-02-10",
    status: "Completed",
  },
];

interface Option {
  name: string;
  code: string;
}
interface categoryOption {
  active_thumbnail: string;
  code: string;
  entity_type: string;
  is_deactivate: string;
  name: string;
  parent_id: string;
  predefined_id: string;
  thumbnail: string;
  url: string;
}
export default function ServiceBooking() {
  const basePath = process.env.REACT_APP_BASE_PATH;
  const toast = useRef<Toast>(null);
  const [activeTab, setActiveTab] = useState<"packages" | "vehicle">(
    "packages",
  );
  const [geoLocation, setGeoLocation] = useState("Fetching location...");
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState<string>("All");
  const [selectedServiceForCheckout, setSelectedServiceForCheckout] = useState(
    null,
  ) as any;
  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [selectedCarId, setSelectedCarId] = useState(null) as any;
  const [selectedVehicleId, setSelectedVehicleId] = useState<string | null>(
    null,
  );
  const [city, setCity] = useState([]) as any;
  const [filteredServicePoint, setFilteredServicePoint] = useState(null) as any;
  const [userId, setUserId] = useState(null) as any;
  const [appointments, setAppointments] =
    useState<Appointment[]>(INITIAL_APPOINTMENTS);
  const [hideWalletAndCoupon, setHideWalletAndCoupon] = useState(false) as any;
  // Booking states
  const [isPopupOpen, setIsPopupOpen] = useState(true);
  const [activeService, setActiveService] = useState<Service | null>(null);
  const [specialInstructions, setSpecialInstructions] = useState("");

  const [successBooking, setSuccessBooking] = useState<{
    service: Service;
    vehicle: Vehicle;
  } | null>(null);

  // Dynamic show of vehicle form inside My Vehicles tab
  const [showDirectAddVehicleForm, setShowDirectAddVehicleForm] =
    useState(false);

  // Handle service card click - open popup
  const handleSelectVehicleForService = (service: Service) => {
    setActiveService(service);
    // setIsPopupOpen(true);
    setIsProceeding(true);
    fetchCityList();
  };
  const [useWalletBalance, setUseWalletBalance] = useState(false) as any;
  const useWalletBalanceFunc = async (e: any) => {
    setUseWalletBalance(e.checked);
    // }
  };
  // Add new vehicle to profile
  const handleAddNewVehicle = (newVehicleData: Omit<Vehicle, "id">) => {
    const newId = `v_${Date.now()}`;
    const createdVehicle: Vehicle = {
      id: newId,
      ...newVehicleData,
    };
    setVehicles([...vehicles, createdVehicle]);
    setSelectedVehicleId(newId);
    setShowDirectAddVehicleForm(false);
  };
  const { cartSave, moveToWishlist, getPaymentLink, getPaymentStatus } =
    useCartAPI();
  const [isLocationSelected, setIsLocationSelected] = useState(false);
  const [isSchedulingAppointment, setIsSchedulingAppointment] = useState(false);
  const [selectedServicePoint, setSelectedServicePoint] = useState<any>(null);
  const [selectedServicePointData, setSelectedServicePointData] = useState<
    any[]
  >([]);
  const [servicePoints, setServicePoints] = useState([]) as any;
  const [isProceeding, setIsProceeding] = useState(false);
  const [walletBalance, setWalletBalance] = useState([]) as any;
  const [pickedTime, setPickedTime] = useState(null) as any;
  const [pickedTimeOptions, setPickedTimeOptions] = useState([]) as any;
  const [categories, setCategories] = useState<categoryOption[]>([]);
  const [typesPreDefinedState, setTypesPreDefinedState] = useState([]);
  const [tyreType, setTyreType] = useState<Option | null | string>(null) as any;
  const [serviceAndRepairsData, setServiceAndRepairsData] = useState([]) as any;
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
  const [cars, setCars] = useState([]) as any;

  const [selectedService, setSelectedService] = useState<Service | null>(null);
  const [pickedDateState, setPickedDateState] = useState(null) as any;
  const [isServiceLoading, setIsServiceLoading] = useState(false);
  const [showOrderConfirmationDialog, setShowOrderConfirmationDialog] =
    useState(false);
  const handleBookService = (service: Service, vehicle: Vehicle) => {
    // console.log("handleBookService called with:", service, vehicle);
    setSelectedService(service);

    setSelectedServiceForCheckout(service);

    setSelectedVehicle(vehicle);

    setIsPopupOpen(false); // Close Vehicle Popup
    getPackageFunction(selectedCategory, vehicle?.variant_id);

    // setIsProceeding(true); // Open Service Point Dialog
  };
  // const handleBookService = (service: Service, vehicle: Vehicle) => {
  //   setSelectedService(service);

  //   setSelectedVehicle(vehicle);

  //   setIsPopupOpen(false); // Close Vehicle Popup

  //   setIsProceeding(true); // Open Service Point Dialog
  // };
  const handleLocationSelect = (e: any) => {
    setSelectedServicePoint(e.value);
    if (typeof e.value === "object") {
      setIsLocationSelected(true);
    }
  };

  const getPackageFunction = async (service_type_id: any, variant_id: any) => {
    setIsServiceLoading(true);
    try {
      const payload = {
        service_type_id: service_type_id ?? selectedService,
        variant_id: variant_id,
      };

      const response = await getPackageFunc(payload);

      if (response.status === 200) {
        const filterlist = response?.data?.map((item: any) => ({
          service_id: item?.service_id,
          approxTime: item?.approx_time,
          offer_price: item?.offer_price,
          isBestSeller: item?.isBestSeller,
          category: item?.service_sub_type?.name,
          description: item?.description,
          title: item?.service_name,
          image:
            item?.service_img[0]?.document?.file_path ||
            item?.service_document[0]?.document?.file_path,
        }));
        // console.log("filterlist", response?.data, filterlist);

        setFilteredServices(filterlist);
      }
    } catch (error) {
    } finally {
      setIsServiceLoading(false);
    }
  };

  const search = (event: any) => {
    setTimeout(() => {
      let _filteredServicePoint: any;

      if (!event.query.trim().length) {
        _filteredServicePoint = [...city];
      } else {
        _filteredServicePoint = city.filter((country: any) => {
          return country.name
            .toLowerCase()
            .startsWith(event.query.toLowerCase());
        });
      }

      setFilteredServicePoint(_filteredServicePoint);
    }, 250);
  };
  const dispatch = useDispatch();
  const fetchServicePoints = async (predefined_id: any) => {
    const payload = {
      city_id: predefined_id,
    };
    const response: any = await getServicePointList(payload, "", "");
    if (response.status === 200) {
      setServicePoints(response.data);
    } else {
      dispatch(setLoading(false));
    }
  };
  const handleLocationSelection = async (e: any) => {
    fetchServicePoints(e.value.predefined_id);
  };
  const itemTemplate = (item: any) => {
    return (
      <div className="auto-complete-text-wrapper">
        <div className="auto-complete-container">
          <Image
            alt={item.name}
            src={locationPin}
            className={`auto-complete-pin-img`}
            // style={{ width: "26px" }}
          />
          <div>{item.name}</div>
        </div>
        <hr />
      </div>
    );
  };

  const handleOrderConfirmationClose = () => {
    setShowOrderConfirmationDialog(false);
    navigate(`${basePath}profile`, {
      state: {
        orderSuccess: true,
        orderId: "test",
      },
    });
  };

  const { getWalletBalance } = useWalletAPI();
  const { getServicePointList } = usePreDefinedListAPI();
  const { saveCustomOrderAPI } = useOrderAPI();
  const { predefinedFunc } = useHeroAPI();
  const { getPackageFunc } = usePackageAPI();
  const { getVehicleList, saveVehicle } = useVehicleAPI();
  const handleDoneBooking = () => {
    setSuccessBooking(null);
    setActiveService(null);
    setActiveTab("packages"); // Direct the user back to services packages!
  };

  // Filter services
  const [filteredServices, setFilteredServices] = useState<Service[]>([]);
  // const filteredServices =
  //   selectedCategory === "All"
  //     ? INITIAL_SERVICES
  //     : INITIAL_SERVICES.filter((s) => s.category === selectedCategory);
  const handleRemoveLocation = () => {
    setSelectedServicePoint(null);
    setIsLocationSelected(false);
    setIsSchedulingAppointment(false);
    setPickedDateState(null);
  };
  const paymentStatusNew = async (paymentId: any, razorpayPaymentId: any) => {
    const pickedTimeVar: any = pickedTimeOptions.find(
      (time: any) => time.code === pickedTime,
    );

    const payload = {
      user_id: userId,
      service_point_id: selectedServicePointData[0]?.service_point_id,
      service_start_date: format(new Date(pickedDateState), "yy"),
      service_start_time_id: pickedTimeVar?.code,
      vehicle_id: selectedCarId?.id,
      is_use_wallet: useWalletBalance,
      order_items: [
        {
          service_id: selectedServiceForCheckout?.service_id,
          item_quantity: 1,
          item_price: selectedServiceForCheckout?.offer_price,
        },
      ],
    };

    const orderSaveResponse: any = await saveCustomOrderAPI(payload);

    if (
      orderSaveResponse?.status === 200 ||
      orderSaveResponse?.status === 201
    ) {
      // setTimeout(() => {
      //   navigate(`${basePath}profile`);
      // }, 500);

      setShowOrderConfirmationDialog(true);

      return toast?.current?.show({
        severity: "success",
        summary: "Successful",
        detail: `Payment Successful`,
      });
    } else {
      dispatch(setLoading(false));
    }
  };

  const fetchVehicleList = async (userId: string) => {
    try {
      const payload = {
        user_id: userId,
      };

      const response: any = await getVehicleList(payload);

      const vehicleData = response?.data?.map((vehicle: any) => ({
        id: vehicle.id,
        color: vehicle.vehicle_color || "N/A",
        nickname:
          `${vehicle?.make?.name} ${vehicle?.model?.name} ${vehicle?.variant?.name}` ||
          "Name Not Available",
        vin: vehicle.vehicle_number,
        // imageUrl: vehicleText,
        make: vehicle?.make?.name,
        model: vehicle?.model?.name,
        variant: vehicle?.variant?.name,
        variant_id: vehicle?.variant?.predefined_id,
      }));
      // console.log("vehicleData", vehicleData);
      setVehicles(vehicleData);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }
  };

  const openRazorpayCheckout = (orderData: any) => {
    const options = {
      key: orderData.key,
      amount: orderData.amount, // Amount in paise
      currency: orderData.currency || "INR",
      name: "Acme Corp",
      description: "Test Transaction",
      image: "https://example.com/your_logo",
      order_id: orderData.id,

      callback_url: "https://eneqd3r9zrjok.x.pipedream.net/",

      prefill: {
        name: "testing",
        email: "testing@gmail.com",
        contact: "9090909090",
      },

      notes: {
        address: "Razorpay Corporate Office",
      },

      theme: {
        color: "#642088",
      },

      handler: function (response: any) {
        // console.log("Payment Success:", response);

        paymentStatusNew(orderData.payment_id, response?.razorpay_payment_id);
        // console.log(
        //   "response.razorpay_payment_id",
        //   response?.razorpay_payment_id,
        // );
        // console.log("response.razorpay_order_id", response?.razorpay_order_id);
        // console.log(
        //   "response.razorpay_signature",
        //   response?.razorpay_signature,
        // );
        // console.log("orderData.payment_id", orderData.payment_id);
        toast?.current?.show({
          severity: "success",
          summary: "Payment Successful",
          detail: `Payment ID: ${response.razorpay_payment_id}`,
        });
      },

      modal: {
        ondismiss: function () {
          console.log("Payment popup closed");
        },
      },
    };

    const razorpay = new window.Razorpay(options);

    razorpay.on("payment.failed", function (response: any) {
      console.error("Payment Failed:", response.error);
      toast?.current?.show({
        severity: "error",
        summary: "Payment Failed",
        detail: response.error.description,
      });
    });

    razorpay.open();
  };

  const serviceCheckout = async () => {
    setIsProceeding(false);

    const pickedTimeVar: any = pickedTimeOptions.find(
      (time: any) => time.code === pickedTime,
    );

    const payload = {
      user_id: userId,
      service_point_id: selectedServicePointData[0]?.service_point_id,
      service_start_date: format(new Date(pickedDateState), "yyyy-MM-dd"),
      service_start_time_id: pickedTimeVar?.code,
      vehicle_id: selectedCarId?.id,
      is_use_wallet: useWalletBalance,
      order_items: [
        {
          service_id: selectedServiceForCheckout?.service_id,
          item_quantity: 1,
          item_price: selectedServiceForCheckout?.offer_price,
        },
      ],
    };

    let response: any;

    if (selectedService?.offer_price === 0) {
      response = await saveCustomOrderAPI(payload);
    } else {
      const payload = {
        user_id: userId,
        amount: selectedServiceForCheckout?.offer_price,
        is_wallet: useWalletBalance,
      };

      // const responsePayment: any = await getPaymentLink(payload);
      // console.log("responsePayment", responsePayment);

      // openRazorpayCheckout(responsePayment?.data);
      const responsePayment: any = await getPaymentLink(payload);
      // console.log("responsePayment", responsePayment);

      if (!responsePayment?.data?.key) {
        dispatch(setLoading(false));
        toast?.current?.show({
          severity: "error",
          summary: "Payment Error",
          detail: "Unable to initiate payment. Please try again.",
        });
        return;
      }

      openRazorpayCheckout(responsePayment.data);
    }
  };

  const pickedTimeVar: any = pickedTimeOptions.find(
    (time: any) => time.code === pickedTime,
  );
  const footerContentTwo = (
    <div className="select-location-footer">
      <Button
        label="Cancel"
        onClick={() => setIsProceeding(false)}
        className="p-button-text select-location-footer-cancel"
      />
      <Button
        label="Confirm Booking"
        onClick={() => serviceCheckout()}
        autoFocus
        disabled={!pickedTime || !pickedDateState}
        className="select-location-footer-confirm"
      />
    </div>
  );
  const getDirectionFunc = (lat: any, lng: any) => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    // Simulate a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up the DOM
    document.body.removeChild(link);
  };
  const handleScheduleAppointment = (e: any, servicePoint: any) => {
    e.preventDefault();
    setSelectedServicePointData([servicePoint]);
    setIsSchedulingAppointment(true);
    fetchTimeSlots();
  };
  const handleLocationChange = () => {
    setIsSchedulingAppointment(false);
    setPickedDateState(null);
  };
  const handleDateSelect = (date: Date) => {
    const startOfSelectedDate = new Date(date.setHours(0, 0, 0, 0));
    const startOfToday = new Date(new Date().setHours(0, 0, 0, 0));
    const endOfRange = new Date(
      startOfToday.getTime() + 9 * 24 * 60 * 60 * 1000,
    );

    const isDateInRange = isWithinInterval(startOfSelectedDate, {
      start: startOfToday,
      end: endOfRange,
    });

    if (isDateInRange) {
      setPickedDateState(startOfSelectedDate);
    } else {
      setPickedDateState(null);
    }
  };
  const handleTimeChange = (e: any) => {
    setPickedTime(e.value);
  };
  const handleCurrentLocation = () => {
    const location = localStorage.getItem("locationM");

    let cityName = "";

    if (location && location.includes("-")) {
      cityName = location.split("-")[0].trim();
    } else {
      cityName = location || "";
    }

    const matchedCity = city.find(
      (c: any) => c.name.toLowerCase() === cityName.toLowerCase().trim(),
    );
    // console.log("Location:", location);
    // console.log("City Name:", cityName);
    // console.log("City Array:", city);
    if (!matchedCity) {
      console.log("City not found:", cityName);
      return;
    }
    // console.log(matchedCity, "SSSS");
    setSelectedServicePoint(matchedCity);
    setIsLocationSelected(true);
    fetchServicePoints(matchedCity.predefined_id);
  };

  const fetchCityList = async () => {
    const cityPayload = { entity_type: "CITY" };
    const predefinedCityResponse = await predefinedFunc(cityPayload);
    if (predefinedCityResponse.status === 200) {
      setCity(predefinedCityResponse?.data?.data);
    } else {
      dispatch(setLoading(false));
    }
  };
  const fetchCurrentLocation = async (manually = false) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDj9D7Sm1MLG1y4CimROoQu1SSUl4OnHyI`,
            );
            const data = await response.json();
            if (data.results && data.results[0]) {
              const addressComponents = data.results[0].address_components;

              const localityComponent = addressComponents.find(
                (component: { types: string | string[] }) =>
                  component.types.includes("locality"),
              );
              const localityShortName = localityComponent?.short_name || "";

              const postalCodeComponent = addressComponents.find(
                (component: { types: string | string[] }) =>
                  component.types.includes("postal_code"),
              );
              const postalCode = postalCodeComponent?.short_name || "";

              const location = postalCode
                ? `${localityShortName} - ${postalCode}`
                : localityShortName;

              setGeoLocation(location);
              localStorage.setItem("locationM", location);
            } else {
              setGeoLocation("Select Location - Unknown Pincode");
              localStorage.setItem("locationM", "");
            }
          } catch (error) {
            console.error("Error fetching address:", error);
            setGeoLocation("Error retrieving location.");
          }
        },
        (error) => {
          console.error("Error getting location:", error);
          setGeoLocation("Unable to retrieve location.");
          if (manually) {
            alert("Please enable location access.");
          }
        },
      );
    } else {
      setGeoLocation("Geolocation is not supported by your browser.");
    }
  };
  const fetchTimeSlots = async () => {
    const predefinedTimePayload = { entity_type: "TIME" };
    const predefinedTimeResponse = await predefinedFunc(predefinedTimePayload);

    const getStartTimeInMinutes = (timeRange: string) => {
      let startTime = timeRange.split("-")[0].trim().replace(".", ":");
      const [time, period] = startTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      return hours * 60 + minutes;
    };

    if (predefinedTimeResponse.status === 200) {
      const predefineTime = predefinedTimeResponse?.data?.data
        .map((child: any) => ({ name: child.name, code: child.predefined_id }))
        ?.sort(
          (a: any, b: any) =>
            getStartTimeInMinutes(a.name) - getStartTimeInMinutes(b.name),
        );
      setPickedTimeOptions(predefineTime);
    } else {
      dispatch(setLoading(false));
    }
  };
  const [isShowPrice, setIsShowPrice] = useState(false);
  useEffect(() => {
    const authTokens: any = JSON.parse(
      localStorage.getItem("authTokens") || "{}",
    );
    if (authTokens?.user?.id) {
      setUserId(authTokens.user.id);
      fetchVehicleList(authTokens.user.id);
    }
    // fetchCityList();
    // fetchTimeSlots();
    setIsShowPrice(authTokens?.user?.is_show_price === true);
    fetchCurrentLocation();
  }, []);

  const fetchPredefined = async () => {
    // const predefinedParentPayload = {
    //   entity_type: "CATEGORY",
    // };
    // const predefinedResponse = await predefinedFunc(predefinedParentPayload);
    // if (predefinedResponse.status === 200) {
    //   console.log("predefinedResponse", predefinedResponse?.data?.data);
    //   setCategories(predefinedResponse?.data?.data);
    //   setTypesPreDefinedState(predefinedResponse?.data?.data);
    //   const defaultTyreType = predefinedResponse?.data?.data?.find(
    //     (type: any) => type?.code === "TWO-WHEELER",
    //   );
    //   setTyreType(defaultTyreType);

    //   const twoWheelerIndex = predefinedResponse?.data?.data.findIndex(
    //     (type: any) => type.code === "TWO-WHEELER",
    //   );
    //   if (twoWheelerIndex !== -1) {
    //     dispatch(setTabIndex(twoWheelerIndex));
    //   }
    // }
    // fetchChildPredefined();

    const predefinedServices = {
      entity_type: "SERVICE-TYPE",
    };
    const predefinedServiceResponse = await predefinedFunc(predefinedServices);
    console.log(
      predefinedServiceResponse,
      "predefinedServiceResponse::::::::::::::",
    );
    if (predefinedServiceResponse.status === 200) {
      setCategories(predefinedServiceResponse?.data?.data);
      setSelectedCategory(
        predefinedServiceResponse?.data?.data[0]?.predefined_id,
      );
      // getPackageFunction(predefinedServiceResponse?.data?.data[0]?.predefined_id);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchPredefined();
    };
    fetchData();
  }, []);
  useEffect(() => {
    getPackageFunction(selectedCategory, selectedVehicle?.variant_id ?? null);
  }, [selectedCategory]);
  return (
    <div className={styles.container}>
      {/* Main Body */}
      <main className={styles.mainContent}>
        {successBooking ? (
          <BookingSuccess
            service={successBooking.service}
            vehicle={successBooking.vehicle}
            onDone={handleDoneBooking}
          />
        ) : (
          <>
            {/* View Switching based on Active Tab */}
            {activeTab === "packages" && (
              <div id="packages-tab-view">
                <div className={styles.headerSection}>
                  <h1 className={styles.title}>Popular Services</h1>
                  <p className={styles.subtitle}>
                    Precision maintenance for peak performance
                  </p>
                </div>

                <div className={styles.filterBar}>
                  {categories.map((cat) => (
                    <button
                      key={cat?.predefined_id}
                      className={`${styles.chip} ${
                        selectedCategory === cat?.predefined_id
                          ? styles.chipActive
                          : ""
                      }`}
                      onClick={() => setSelectedCategory(cat?.predefined_id)}
                    >
                      <img
                        src={cat?.url ? cat?.url : carStand}
                        alt={cat?.name}
                        className={styles.categoryIcon}
                      />
                      <span className="text">{cat?.name}</span>
                    </button>
                  ))}
                </div>

                {/* Service Cards Grid */}
                <div className={styles.servicesGrid}>
                  {/* {filteredServices?.length > 0 && filteredServices.map((service) => (
                    <ServiceCard
                      key={service.id}
                      service={service}
                      onSelectVehicle={handleSelectVehicleForService}
                    />
                  ))} */}
                  {isServiceLoading ? (
                    <AppSkeleton
                      count={6}
                      width="100%"
                      height="340px"
                      borderRadius="16px"
                    />
                  ) : filteredServices?.length > 0 ? (
                    filteredServices.map((service) => (
                      <ServiceCard
                        key={service.id}
                        service={service}
                        onSelectVehicle={handleSelectVehicleForService}
                        vehicleId={selectedVehicle?.id}
                        isShowPrice={isShowPrice}
                      />
                    ))
                  ) : (
                    <div className={styles.noServices}>
                      <img
                        src={noProductFound}
                        alt="No services found"
                        className={styles.noServicesImg}
                      />
                      <p className={styles.noServicesText}>
                        No services available for the selected type.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "vehicle" && (
              <div id="vehicle-tab-view" className={styles.vehicleView}>
                <div className={styles.vehicleHeaderRow}>
                  <div>
                    <h1 className={styles.title}>My Vehicles</h1>
                    <p className={styles.subtitle}>
                      Manage your vehicle garage
                    </p>
                  </div>
                  <button
                    id="add-vehicle-btn-direct"
                    className={styles.addNewVehicleBtn}
                    onClick={() => {
                      setActiveService(null);
                      setIsPopupOpen(true); // Open the main vehicle popup where they can add vehicles
                    }}
                  >
                    <BiPlus size={16} />
                    <span>Add Vehicle</span>
                  </button>
                </div>

                <div
                  className={styles.servicesGrid}
                  style={{ gridTemplateColumns: "1fr" }}
                >
                  {vehicles.map((v) => (
                    <div
                      key={v.id}
                      style={{
                        border: "1px solid #e2e8f0",
                        borderRadius: "12px",
                        padding: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "16px",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            backgroundColor: "#f3e8ff",
                            color: "#642088",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <FiTruck size={20} />
                        </div>
                        <div>
                          <h3
                            style={{
                              margin: "0 0 4px 0",
                              fontWeight: "700",
                              fontSize: "1.1rem",
                            }}
                          >
                            {v.year} {v.make} {v.model}
                          </h3>
                          <div
                            style={{
                              fontSize: "0.8rem",
                              color: "#64748b",
                              fontFamily: "monospace",
                            }}
                          >
                            VIN: {v.vin}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "6px",
                              marginTop: "8px",
                            }}
                          >
                            {v.tags?.map((t, idx) => (
                              <span
                                key={idx}
                                style={{
                                  fontSize: "0.65rem",
                                  backgroundColor: "#f1f5f9",
                                  color: "#475569",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  fontWeight: "700",
                                }}
                              >
                                {t}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          fontSize: "0.8rem",
                          color: "#64748b",
                          fontWeight: "600",
                        }}
                      >
                        LAST SERVICE: {v.lastService}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </main>

      {/* Select Vehicle Popup / Modal */}
      <VehiclePopup
        isOpen={isPopupOpen}
        onClose={() => {
          setIsPopupOpen(false);
          setActiveService(null);
        }}
        vehicles={vehicles}
        onAddVehicle={handleAddNewVehicle}
        selectedVehicleId={selectedVehicleId}
        onSelectVehicleId={(id) => setSelectedVehicleId(id)}
        activeService={activeService}
        onBookService={handleBookService}
      />
      <Dialog
        header="Select a service point"
        visible={isProceeding}
        style={{ width: "70%" }}
        onHide={() => setIsProceeding(false)}
        footer={isSchedulingAppointment ? footerContentTwo : ""}
        className="is-proceeding-header"
      >
        {isLocationSelected && !isSchedulingAppointment && (
          <div className="selected-location-container">
            <div className="selected-location-wrapper">
              <div className="selected-location">
                <MdLocationOn
                  className="selected-location-icon"
                  style={{ cursor: "pointer" }}
                />
                <span className="selected-location-text">
                  {selectedServicePoint?.name}
                </span>
              </div>
              <Button
                className={styles.changeLocationButton}
                onClick={handleRemoveLocation}
              >
                Change Location
              </Button>
            </div>
            <div className="store-near-location-wrapper">
              <div
                className="store-near-location-title"
                style={{ marginBottom: "10px" }}
              >
                Stores Near Your Location
              </div>
              <div className="store-near-location-list">
                {servicePoints.map((servicePoint: any, index: number) => (
                  <div className="service-point-card" key={index}>
                    <div className="service-point-name-wrapper">
                      <div className="service-point-name">
                        {servicePoint.service_point_name}
                      </div>
                      <div className="service-point-distance">
                        {/* {servicePoint.distance || "Distance"} */}
                      </div>
                    </div>
                    <div
                      className="service-point-meta-wrapper"
                      style={{ minHeight: "53px" }}
                    >
                      <div className="service-point-opens">
                        <CiClock2 />
                        {`Opens At ${
                          servicePoint.service_point_open_time || "Time"
                        }`}
                      </div>
                      <div className="service-point-address">
                        <CiLocationOn />
                        {servicePoint.service_point_address || "Address"}
                      </div>
                    </div>
                    {/* <div className="service-point-rating">
                      <StarPicker
                        value={parseInt(servicePoint.rating) || "2.5"}
                        halfStars
                        disabled={true}
                        size={15}
                      />
                      {servicePoint.rating || "0"}
                    </div> */}
                    <div className="service-point-actions">
                      <div className="service-point-actions-btns">
                        <Button
                          className="get-direction-button"
                          style={{ fontSize: "10px" }}
                          icon={
                            <CiLocationArrow1 style={{ fontSize: "14px" }} />
                          }
                          label="Get Direction"
                          onClick={() =>
                            getDirectionFunc(servicePoint.lat, servicePoint.lng)
                          }
                        />
                        <Button
                          style={{
                            padding: "2px 10px",
                            gap: "1px",
                            fontSize: "10px",
                          }}
                          className="schedule-appointment-button"
                          icon={
                            <MdOutlineCalendarMonth
                              style={{ fontSize: "16px" }}
                            />
                          }
                          label="Schedule Appointment"
                          onClick={(e) =>
                            handleScheduleAppointment(e, servicePoint)
                          } // Pass the servicePoint here
                        />
                      </div>
                      <div className="service-point-actions-img-container">
                        {servicePoint?.service_group?.image_url && (
                          <Image
                            src={servicePoint?.service_group?.image_url}
                            className="service-point-actions-img"
                            style={{ height: "50px" }}
                          />
                        )}
                        {!servicePoint?.service_group?.image_url && (
                          <MdDoNotDisturb
                            style={{
                              height: "25px",
                              width: "25",
                              marginTop: "5px",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {isLocationSelected && isSchedulingAppointment && (
          <div className="selected-location-container">
            <div className="selected-location-wrapper">
              <div className="selected-location">
                <MdLocationOn className="selected-location-icon" />
                <span className="selected-location-text">
                  {selectedServicePoint?.name}
                </span>
              </div>
              <Button
                // className="change-Location-button"
                className={styles.changeLocationButton}
                onClick={handleRemoveLocation}
              >
                Change Location
              </Button>
            </div>
            <div className="store-near-location-wrapper">
              <div className="store-near-location-wrapper">
                <div className="store-near-location-title">
                  Stores Near Your Location
                </div>
                <div
                  className="store-near-location-list"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0px 0px 4px #642088",
                  }}
                >
                  {selectedServicePointData.map(
                    (servicePoint: any, index: number) => (
                      <div className="selected-store-point-wrapper">
                        <div className="store-point-info">
                          {/* <img
                            src={servicePoint.image || servicePointImage}
                            alt={servicePoint.service_point_name}
                            className="store-station-image"
                          /> */}
                          <div className="store-point-details">
                            <div className="store-point-name">
                              {servicePoint.service_point_name}
                            </div>
                            <div className="store-point-address">
                              {servicePoint.service_point_address ||
                                "Address Not Available"}
                            </div>
                          </div>
                        </div>
                        <div className="change-store-button-wrapper">
                          <Button
                            className={styles.changestorebutton}
                            onClick={handleLocationChange}
                          >
                            Change Service Point
                          </Button>
                        </div>
                      </div>
                    ),
                  )}
                </div>
                <div className="schedule-your-appointment-wrapper">
                  <div className="store-near-location-title">
                    Schedule your appointment
                  </div>
                  <div className="schedule-your-appointment-container">
                    <div
                      className="pick-a-date-wrapper width-50"
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 4px #642088",
                      }}
                    >
                      <div className="pick-a-date-title">
                        Pick A Date
                        <Calendar
                          value={pickedDateState}
                          onChange={(e: any) => setPickedDateState(e.value)}
                          showIcon
                          className={styles.pickDateCalendar}
                          placeholder="Select Manually"
                          minDate={new Date()}
                        />
                      </div>
                      <div className="horizontal-pick-a-date">
                        <HorizontalDatePicker
                          startDate={
                            new Date(new Date().setDate(new Date().getDate()))
                          }
                          endDate={
                            new Date(
                              new Date().getTime() + 9 * 24 * 60 * 60 * 1000,
                            )
                          }
                          onDateSelect={handleDateSelect}
                          externalSelectedDate={pickedDateState}
                        />
                      </div>
                    </div>
                    <div
                      className="pick-a-time-wrapper width-50"
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 4px #642088",
                      }}
                    >
                      <div className="pick-a-time-title-wrapper">
                        <div className="pick-a-time-title">Pick A Time</div>
                        <div className="pick-a-time-calender-wrapper">
                          <Dropdown
                            value={pickedTime}
                            onChange={(e) => handleTimeChange(e)}
                            options={pickedTimeOptions}
                            virtualScrollerOptions={{ itemSize: 38 }}
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select Item"
                            className="pick-a-time-dropdown w-full"
                          />
                        </div>
                      </div>
                    </div>
                    {hideWalletAndCoupon && (
                      <div className="wallet-discount-wrapper col-6">
                        <div className="wallet-container wallet-container-2">
                          <div className="wallet-title-wrapper">
                            {/* <Image
                              src={walletIcon}
                              alt="walletIcon"
                              className="wallet-icon"
                            /> */}

                            <div className="wallet-text-wrapper">
                              <div className="wallet-title">Wallet</div>

                              <div className="wallet-amount">
                                Wallet Balance: &#8377;{walletBalance ?? 0}
                              </div>

                              <div className="wallet-checkbox-row">
                                <Checkbox
                                  onChange={useWalletBalanceFunc}
                                  checked={useWalletBalance}
                                  inputId="wallet-balance"
                                  className="wallet-small-checkbox"
                                />

                                <label
                                  htmlFor="wallet-balance"
                                  className="wallet-checkbox-label"
                                >
                                  Use wallet balance
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className="schedule-appointment-wrapper"
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 4px #642088",
                      }}
                    >
                      <div className="schedule-appointment-title">
                        Special Instruction
                      </div>
                      <InputText
                        value={specialInstructions}
                        onChange={(e: any) =>
                          setSpecialInstructions(e.target.value)
                        }
                        className="schedule-appointment-input"
                        style={{ borderRadius: "10px" }}
                        placeholder="Enter Special Instruction"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!isLocationSelected && (
          <span className="w-full">
            <AutoComplete
              field="name"
              value={selectedServicePoint}
              suggestions={filteredServicePoint}
              completeMethod={search}
              onChange={(e) => handleLocationSelect(e)}
              itemTemplate={itemTemplate}
              // panelFooterTemplate={panelFooterTemplate}
              className="service-point-auto-complete"
              placeholder="Enter a location"
              onSelect={(e) => handleLocationSelection(e)}
            />
            <div className="auto-complete-icons-wrapper p-input-icon-right">
              <MdSearch
                style={{ cursor: "pointer" }}
                className="auto-complete-search-location"
              />
              <MdGpsFixed
                style={{ cursor: "pointer" }}
                className="auto-complete-choose-location"
                onClick={() => handleCurrentLocation()}
              />
            </div>
          </span>
        )}
      </Dialog>
      <Dialog
        visible={showOrderConfirmationDialog}
        onHide={handleOrderConfirmationClose}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "70vw", "641px": "95vw" }}
        showHeader={false}
        closable={false}
        className="order-success-dialog"
      >
        <div className="order-success-content">
          <div className="order-success-icon-wrapper">
            <i className="pi pi-check-circle order-success-icon" />
          </div>
          <h3 className="order-success-title">Order Completed</h3>
          <p className="order-success-message">
            Your order has been successfully completed
          </p>
          <Button
            label="View Details"
            className="order-success-cta"
            onClick={handleOrderConfirmationClose}
            autoFocus
          />
        </div>
      </Dialog>
    </div>
  );
}
